/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  DeleteApiV1BankId202,
  DeleteApiV1BankId401,
  DeleteApiV1BankId404,
  DeleteApiV1BankId409,
  DeleteApiV1BankId500,
  DeleteApiV1BankIdMutationResponse,
  DeleteApiV1BankIdPathParams,
} from "../../types/bankRegistroController/DeleteApiV1BankId.ts";

export const deleteApiV1BankIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<DeleteApiV1BankIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const deleteApiV1BankId202Schema =
  z.any() as unknown as ToZod<DeleteApiV1BankId202>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const deleteApiV1BankId401Schema =
  z.any() as unknown as ToZod<DeleteApiV1BankId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const deleteApiV1BankId404Schema =
  z.any() as unknown as ToZod<DeleteApiV1BankId404>;

/**
 * @description (Conflict) Há um conflito com os dados existentes.
 */
export const deleteApiV1BankId409Schema =
  z.any() as unknown as ToZod<DeleteApiV1BankId409>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const deleteApiV1BankId500Schema =
  z.any() as unknown as ToZod<DeleteApiV1BankId500>;

export const deleteApiV1BankIdMutationResponseSchema = z.lazy(
  () => deleteApiV1BankId202Schema,
) as unknown as ToZod<DeleteApiV1BankIdMutationResponse>;
